/** The person's photo, cut to a centred square and shrunk in the browser, so a phone camera shot arrives small. */

/** The photo's side, in pixels: plenty for a circle, small on the wire. */
const PHOTO_SIDE = 512;

/** Cut the picture to a centred square of PHOTO_SIDE and hand it back as a JPEG. */
export async function squarePhoto(file: File, side = PHOTO_SIDE): Promise<File> {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = () => reject(new Error("That picture could not be read."));
      el.src = url;
    });
    const size = Math.min(img.naturalWidth, img.naturalHeight);
    if (!size) throw new Error("That picture could not be read.");
    const canvas = document.createElement("canvas");
    const out = Math.min(side, size);
    canvas.width = out;
    canvas.height = out;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("That picture could not be read.");
    ctx.drawImage(img, (img.naturalWidth - size) / 2, (img.naturalHeight - size) / 2, size, size, 0, 0, out, out);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.86));
    if (!blob) throw new Error("That picture could not be read.");
    return new File([blob], "photo.jpg", { type: "image/jpeg" });
  } finally {
    URL.revokeObjectURL(url);
  }
}
